import StandingGameMetaParticipantsModel from "./StandingGameMetaParticipantsModel";

export default class StandingGameMetaModel {
  public participants: StandingGameMetaParticipantsModel[] = [];
}
